/*
* 工单回访管理组件
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { Space, message, Table, Input, Rate } from 'antd';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    GetButtonActionName,
} from '../../incs/FunHelper.js';

const MODULENAME = CNF.navItems[2].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[2].submenu[1].ptn;
const MODULENAME_URL = CNF.navItems[2].submenu[1].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, refresh } = props;

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh]);

    const hasOpPerm = (
        props.btnLists.includes(MODULENAME_PTN + '_delete')
    );

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        { title: '工单编号', dataIndex: 'number', key: 'number', fixed: 'left', width: 150, },
        {
            title: '客户评分', key: 'rate',
            render: (record) => {
                return <Rate value={record.rate} style={{ fontSize: 13 }} />
            }
        },
        { title: '客户评价', dataIndex: 'evaluation', key: 'evaluation', ellipsis: true, },
        { title: '回访人员', dataIndex: 'visit_displayname', key: 'visit_displayname', },
        { title: '回访日期', dataIndex: 'visit_date', key: 'visit_date', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '操作', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetButtonActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation]);
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                loading={props.loading}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
        </>
    );
}

const WOVisit = (props) => {
    const { btnLists, preGroup } = props;

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);

    const [number, setNumber] = useState('');
    const [visitDisplayname, setVisitDisplayname] = useState('');

    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: CNF.pageSize,
            current_index: currentIndex,
            number,
            visit_displayname: visitDisplayname,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, currentIndex, triggerRefresh, number, visitDisplayname]);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleNumberChange = useCallback((e) => {
        setNumber(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleVisitDisplaynameChange = useCallback((e) => {
        setVisitDisplayname(e.target.value);
        setCurrentIndex(1);
    }, []);


    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    placeholder='工单编号'
                    onChange={handleNumberChange}
                    value={number}
                />
                <Input
                    placeholder='回访人员'
                    onChange={handleVisitDisplaynameChange}
                    value={visitDisplayname}
                />
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                refresh={refresh}
                loading={loading}
            />
        </>
    );
}

export default WOVisit;